// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eab0352a","453":"258b012d","732":"306a8c52","977":"470ec7d1"}[chunkId] + ".chunk.js";
};